import { FormControl, MenuItem, Select } from "@mui/material";
import { menuItemStyles } from "MUITheme";
import React, { useEffect } from "react";

function DropDownInput({
  options,
  value,
  setValueChange,
  labelText,
  mandetory,
  styleProp
}) {
  const handleValueChange = (e) => {
    setValueChange(e.target.value);
  };
  return (
    <FormControl sx={styleProp} >
      <label>
        {labelText}
        {mandetory ? <span style={{ color: "red" }}>*</span> : ""}
      </label>
      <Select
        value={value}
        onChange={handleValueChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        sx={{
          fontSize: "14px", // Adjusts select box font size
        }}
      >
        <MenuItem value="" sx={menuItemStyles}>
          <em style={{ color: "gray" }}>{labelText}</em>
        </MenuItem>
        {options.map((item) => (
          <MenuItem key={item.id} value={item.id} sx={menuItemStyles}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DropDownInput;
